import type { TableOfContent, Course } from '@openclassrooms/sdk-web';
import { ROUTES, getPathName } from '@openclassrooms/routing';

function appendSearchParams(url: string, searchParams?: string) {
  return searchParams ? `${url}?${searchParams}` : url;
}

export default function tocItemToUrl(
  courseItem: Pick<Course, 'id' | 'title' | 'slug'>,
  tocItem: Partial<Pick<TableOfContent, 'id' | 'title' | 'slug' | 'type'>> | null,
  searchParams?: string
) {
  if (!tocItem) {
    const courseDetailRoute = getPathName(ROUTES.COURSES.DETAIL, {
      courseIdSlug: courseItem.slug ? `${courseItem.id}-${courseItem.slug}` : `${courseItem.id}`,
    });

    return appendSearchParams(courseDetailRoute, searchParams);
  }

  const isExercise = tocItem.type === 'MCQ';

  const courseIdSlug = courseItem.slug ? `${courseItem.id}-${courseItem.slug}` : `${courseItem.id}`;
  const chapterSlug = tocItem.slug ? `${tocItem.id}-${tocItem.slug}` : `${tocItem.id}`;

  const route = isExercise ? ROUTES.COURSES.EXERCISES : ROUTES.COURSES.CHAPTERS;
  const params = isExercise
    ? { courseIdSlug, exerciseId: tocItem.id }
    : { courseIdSlug, chapterIdSlug: chapterSlug };

  const link = getPathName(route, params);

  return appendSearchParams(link, searchParams);
}
